/**
 * Patient Creation Route
 * Form for creating new patient records
 * Layout provided by _authenticated parent route
 * Authentication inherited from parent
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';

/**
 * Patient Creation Route Component
 * Layout (MainLayout, Sidebar, sessions panel) provided by parent _authenticated route
 */
const PatientNewRouteComponent = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Create New Patient</h1>
      <p>Patient creation form will be implemented here.</p>
      <button onClick={() => navigate({ to: '/patients' })}>
        ← Back to Patients
      </button>
    </div>
  );
};

/**
 * Route Configuration
 * Path: /_authenticated/patients/new
 * - Authentication inherited from _authenticated parent (no requireAuth needed)
 * - MainLayout structure inherited from _authenticated parent
 */
export const Route = createFileRoute('/_authenticated/patients/new')({
  component: PatientNewRouteComponent,
});
